import React from "react";
import { Box, Chip, LinearProgress, Stack, Typography } from "@mui/material";
import ChecklistRtlRoundedIcon from "@mui/icons-material/ChecklistRtlRounded";

interface QuestionProgressProps {
  currentStep: number;
  totalSteps: number;
  progress: number;
}

export const QuestionProgress: React.FC<QuestionProgressProps> = ({
  currentStep,
  totalSteps,
  progress,
}) => (
  <Stack spacing={1.5} sx={{ width: "100%" }}>
    <Stack direction="row" alignItems="center" spacing={1.5}>
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: 2,
          bgcolor: "primary.main",
          color: "primary.contrastText",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <ChecklistRtlRoundedIcon fontSize="small" />
      </Box>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle2" color="text.secondary">
          Assessment Progress
        </Typography>
        <Typography variant="body2" color="text.primary" fontWeight={600}>
          Step {currentStep} of {totalSteps}
        </Typography>
      </Box>
      <Chip label={`${Math.round(progress)}%`} size="small" color="primary" />
    </Stack>
    <LinearProgress
      variant="determinate"
      value={progress}
      sx={{
        height: 8,
        borderRadius: 99,
        backgroundColor: (theme) => theme.palette.action.hover,
        "& .MuiLinearProgress-bar": {
          borderRadius: 99,
        },
      }}
    />
  </Stack>
);
